module.exports = __webpack_public_path__ + "img/course-cover02.a0106b2f.png";